import { gql } from '@apollo/client';
import type { EventGallery } from '../../../types';

export const GALLERY_QUERY = gql`
  query gallery($galleryId: ID!) {
    gallery(galleryId: $galleryId)
      @rest(type: "EventGallery", method: "GET", path: "/galleries/api/galleries/{args.galleryId}", endpoint: "bff") {
      id
      name
      groups @type(name: "EventGalleryGroup") {
        id
        name
        photos
        photosTotal
      }
      event @export(as: "event") {
        id
        raceRosterEventId
      }
      settings {
        allowParticipantsUpload
        disableSearch
      }
    }
  }
`;

export type GalleryQueryVariables = {
  galleryId: string;
};

export type GalleryQueryResponseData = {
  gallery?: EventGallery;
};
